const OPEN_TOAST: string = 'toast/OPEN_TOAST' as const;
const CLOSE_TOAST: string = 'toast/CLOSE_TOAST' as const;
const SET_TOAST: string = 'toast/SET_TOAST' as const;

type openToastAction = {
    type: typeof OPEN_TOAST;
    payload: null;
};
type closeToastAction = {
    type: typeof CLOSE_TOAST;
    payload: null;
};
type setToastAction = {
    type: typeof SET_TOAST;
    payload: {title: string, message: string};
}


type ActionType = openToastAction | closeToastAction | setToastAction;

export const openToast  = ()     => ({type: OPEN_TOAST});
export const closeToast = ()     => ({type: CLOSE_TOAST});
export const setToast   = ({title, message}: {title: string, message: string}) => ({type: SET_TOAST, payload: {title, message}})

interface InitialStateType {
    isOpen: boolean;
    title: string,
    message: string
};

const initialState: InitialStateType = {
    isOpen: false,
    title: '',
    message: ''
};

export default function toast(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case OPEN_TOAST:
            return {
                isOpen: true,
            };
        case CLOSE_TOAST:
            return {
                isOpen: false,
            };
        case SET_TOAST:
            return {
                isOpen: true,
                title: action.payload?.title,
                message: action.payload?.message,
            }
        default:
            return state;
    }
};